// @ts-nocheck
import { useCallback, useEffect } from 'react'
import Instanoti from '../local_modules/instanoti/instanoti'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store/rootReducer'
import { MemberState } from '../store/member/memberTypings'
import { addNotification, addNotificationInList } from '../store/member/memberSlice'
import { useLocation } from 'react-router-dom'

export const useInstanoti = () => {
    const dispatch = useDispatch()
    // eslint-disable-next-line
    let socket
    const WSS_URL = process.env.RAZZLE_INSTANOTI_SERVER_URL
    const wss_url = WSS_URL

    const loggedIn = useSelector<RootState, MemberState>((state) => state.member.loggedIn)
    const ignoredUsers = useSelector((state: RootState) => state.ephemeral.ignoredUsers)
    const location = useLocation()

    const handleContributionComment = useCallback(
        (data) => {
            dispatch(
                addNotification({
                    type: 'contribution_comment',
                    id: data.data.entity_id,
                    senderNick: data.data.meta.user.nick,
                    senderId: data.data.meta.user.id,
                    text: data.data.message,
                    url: data.data.meta.url
                })
            )
        },
        [dispatch, location.pathname]
    )

    const handleEphemeralComment = useCallback(
        (data) => {
            // if (!location.pathname.includes('/ephemeral')) {
            dispatch(
                addNotification({
                    type: 'ephemeral_comment',
                    id: data.data.entity_id,
                    senderNick: data.data.meta.user.nick,
                    senderId: data.data.meta.user.id,
                    text: data.data.message,
                    url: data.data.meta.url,
                    cover: data.data.meta && data.data.meta.image ? data.data.meta.image : null
                })
            )
            // }
        },
        [dispatch, location.pathname]
    )

    const handleEphemeral = useCallback(
        (data) => {
            const senderId =
                data && data.data && data.data.meta && data.data.meta.user && data.data.meta.user.id
                    ? String(data.data.meta.user.id)
                    : 'notFound'

            if (!ignoredUsers.includes(senderId)) {
                dispatch(
                    addNotification({
                        type: 'ephemeral',
                        id: data.data.entity_id,
                        senderNick: data.data.meta.user.nick,
                        senderId: data.data.meta.user.id,
                        text: data.data.message,
                        url: data.data.meta.url
                    })
                )
            }

            if (!ignoredUsers.includes(senderId)) {
                dispatch(
                    addNotificationInList({
                        type: 'ephemeral',
                        id: data.data.id,
                        date: Number(new Date() / 1000),
                        meta: data.data.meta,
                        visibility: 'personal',
                        is_read: 0,
                        message: data.data.message
                    })
                )
            }
        },
        [dispatch, location.pathname, ignoredUsers.length]
    )

    useEffect(() => {
        if (loggedIn) {
            // eslint-disable-next-line
            const socket = new Instanoti({
                server_uri: wss_url,
                on_open: () => {
                    console.log('---Websocket connected---')
                },
                on_close: () => {
                    console.log('Websocket disconnected')
                },
                on_error: (err) => {
                    console.log('Websocket error', err)
                },
                on_counter: () => {
                    // store.dispatch(setCurrentUserCounters(data));
                },
                on_tip: () => {
                    // store.dispatch(receiveInstantNotification(data));
                },
                on_follower: (data) => {
                    dispatch(
                        addNotification({
                            type: 'follower',
                            id: data.data.entity_id,
                            senderNick: data.data.meta.user.nick,
                            senderId: data.data.meta.user.id,
                            text: data.data.message,
                            url: data.data.meta.url
                        })
                    )
                    dispatch(
                        addNotificationInList({
                            type: 'follower',
                            id: data.data.id,
                            date: Number(new Date() / 1000),
                            meta: data.data.meta,
                            visibility: 'personal',
                            is_read: 0,
                            message: data.data.message
                        })
                    )
                },
                on_gift: (data) => {
                    dispatch(
                        addNotification({
                            type: 'gift',
                            id: data.data.entity_id,
                            senderNick: data.data.meta.user.nick,
                            senderId: data.data.meta.user.id,
                            text: data.data.message,
                            url: data.data.meta.url,
                            image: data.data.meta.image
                        })
                    )
                    dispatch(
                        addNotificationInList({
                            type: 'gift',
                            id: data.data.id,
                            date: Number(new Date() / 1000),
                            meta: data.data.meta,
                            visibility: 'personal',
                            is_read: 0,
                            message: data.data.message
                        })
                    )
                },
                on_message: () => {
                    // check if conversation with this user opened
                },
                on_membership_gift: (data) => {
                    dispatch(
                        addNotification({
                            type: 'premium',
                            duration: data.data.meta.duration,
                            id: data.data.entity_id,
                            senderNick: data.data.meta.user.nick,
                            senderId: data.data.meta.user.id,
                            text: data.data.message,
                            url: data.data.meta.url
                        })
                    )

                    dispatch(
                        addNotificationInList({
                            type: 'membership_gift',
                            id: data.data.id,
                            date: Number(new Date() / 1000),
                            meta: data.data.meta,
                            visibility: 'personal',
                            is_read: 0,
                            message: data.data.message
                        })
                    )
                },
                on_membership_gift_public: () => {
                    // store.dispatch(receiveInstantNotification(data))
                },
                on_guestbook: (data) => {
                    dispatch(
                        addNotification({
                            type: 'guestbook',
                            id: data.data.entity_id,
                            senderNick: data.data.meta.user.nick,
                            senderId: data.data.meta.user.id,
                            text: data.data.message,
                            url: data.data.meta.url
                        })
                    )
                    dispatch(
                        addNotificationInList({
                            type: 'guestbook',
                            id: data.data.id,
                            date: Number(new Date() / 1000),
                            meta: data.data.meta,
                            visibility: 'personal',
                            is_read: 0,
                            message: data.data.message
                        })
                    )
                },
                // on_followee_ephemeral: (data) => {
                //     dispatch(
                //         addNotification({
                //             type: 'followee_ephemeral',
                //             id: data.data.entity_id,
                //             senderNick: data.data.meta.user.nick,
                //             senderId: data.data.meta.user.id,
                //             text: data.data.message,
                //             url: data.data.meta.url,
                //             image: data.data.meta.image
                //         })
                //     )
                //     dispatch(
                //         addNotificationInList({
                //             type: 'followee_ephemeral',
                //             id: data.data.id,
                //             date: Number(new Date() / 1000),
                //             meta: data.data.meta,
                //             visibility: 'personal',
                //             is_read: 0,
                //             message: data.data.message,
                //             cover: data.data.meta.image
                //         })
                //     )
                // },
                on_ephemeral_comment: handleEphemeralComment,
                on_contribution_comment: handleContributionComment,
                on_ephemeral: handleEphemeral,
                on_followee_contribution: (data) => {
                    dispatch(
                        addNotification({
                            type: 'newContribution',
                            id: data.data.id,
                            senderNick: data.data.meta.user.nick,
                            senderId: data.data.meta.user.id,
                            url: data.data.meta.url,
                            cover: data.data.meta.image
                        })
                    )
                    dispatch(
                        addNotificationInList({
                            type: 'followee_contribution',
                            id: data.data.id,
                            date: Number(new Date() / 1000),
                            meta: data.data.meta,
                            visibility: 'personal',
                            is_read: 0,
                            message: data.data.message
                        })
                    )
                },
                on_followed_user_is_online: () => {
                    // store.dispatch(receiveInstantNotification(data, true))
                },
                on_new_personal_room: () => {
                    // store.dispatch(receiveInstantNotification(data, true))
                },
                on_new_showroom: () => {
                    // store.dispatch(receiveInstantNotification(data, true))
                },
                on_user_membership_expired: () => {
                    // store.dispatch(receiveInstantNotification(data))
                },
                on_user_membership_almost_expired: () => {
                    // store.dispatch(receiveInstantNotification(data))
                },
                on_stream_record_error: () => {
                    // store.dispatch(receiveInstantNotification(data))
                },
                reconnect: true
            })
        } else {
            if (window && window.socket) console.log(window.socket)
        }
    }, [loggedIn])
}
